import { StateCreator } from 'zustand';

import { fetchDiceRollMenuCMS } from '@/api/cms';
import { CommonStoreType, DiceRollState } from '@/store/commonStore/types';

export const useDiceRollSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  DiceRollState
> = (set) => {
  return {
    diceRollMenuData: null,
    pendingDiceRollMenuData: false,
    fetchDiceRollMenuData: async (locale: string) => {
      try {
        set({ pendingDiceRollMenuData: true });
        const { data } = await fetchDiceRollMenuCMS(locale);

        set({ diceRollMenuData: data || null });
      } catch (error) {
        console.log(error);
      } finally {
        set({ pendingDiceRollMenuData: false });
      }
    },
  };
};
